import { FieldValues, UseFormSetError } from 'react-hook-form';

export const assignFormErrors = (
  setError: UseFormSetError<FieldValues>,
  error: { data?: { message?: string } },
  fields?: Record<string, string>,
) => {
  if (typeof error?.data?.message === 'object') {
    Object.entries(error?.data?.message).forEach((err: [string, unknown]) => {
      const name = err[0];

      setError(name, {
        type: 'custom',
        message: `${fields ? fields[name] : ''} ${err[1]}`,
      });
    });
  }
};
